import {
    setIsFavoriteOpen, setIsInfoOpen,
    setIsMenuOpen,
    setIsPlay,
    setIsSettingsOpen,
    setSelectedItem,
    setSelectedItemIndex
} from "../../redux/actions";
import React, {useState} from "react";
import styled from "styled-components";
import {useAppDispatch} from "../../redux/store";
import {ReactComponent as PlayNew} from "../../assets/icons/play_new.svg"
import {ReactComponent as PauseNew} from "../../assets/icons/pause_new.svg"
import {ReactComponent as Gear} from "../../assets/icons/gear_new.svg"
import {ReactComponent as BackDownNew} from "../../assets/icons/back_arrow_new.svg"
import {ReactComponent as Favorite} from "../../assets/icons/fav.svg"
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {FavoritesBottomButton, PlayPauseButton, SettingsBottomButton} from "components/ToFlowMain/TOFlow.styled";

export const Footer: React.FC = () => {
    const dispatch = useAppDispatch()
    const selectedItem = useSelector(selectors.selectSelectedItem)
    const isPlay = useSelector(selectors.selectIsPlay)
    const isSettingsOpen = useSelector(selectors.selectIsSettingsOpen)
    const isFavoriteOpen = useSelector(selectors.selectIsFavoriteOpen)
    const isInfoOpen = useSelector(selectors.selectIsInfoOpen)
    return (
        <FooterWrapper>
            <FavoritesBottomButton isOpen={isFavoriteOpen} onClick={() => {
                dispatch(setIsFavoriteOpen(!isFavoriteOpen))
                dispatch(setSelectedItem(undefined))
                dispatch(setSelectedItemIndex(undefined))
                dispatch(setIsMenuOpen(false))
                dispatch(setIsInfoOpen(false))
                dispatch(setIsSettingsOpen(false))
                dispatch(setIsPlay(true))
            }}>
                <Favorite/>
            </FavoritesBottomButton>
            <PlayPauseButton
                isStopped={isPlay && !isSettingsOpen && !isInfoOpen && !isFavoriteOpen}
                onClick={() => {
                    if (selectedItem || isSettingsOpen || isInfoOpen || isFavoriteOpen) {
                        if (selectedItem) {
                            dispatch(setSelectedItem(undefined))
                        }
                        if (isSettingsOpen) {
                            dispatch(setIsSettingsOpen(false))
                        }
                        if (isInfoOpen) {
                            dispatch(setIsInfoOpen(false))
                        }
                        if (isFavoriteOpen) {
                            dispatch(setIsFavoriteOpen(false))
                        }
                    } else {
                        dispatch(setIsPlay(!isPlay))
                    }
                }}
            >
                { selectedItem || isSettingsOpen || isInfoOpen || isFavoriteOpen ? (<BackDownNew/>) : isPlay ? (<PlayNew/>) : (<PauseNew/>)}
            </PlayPauseButton>
            <SettingsBottomButton
                isOpen={isSettingsOpen}
                onClick={() => {
                    dispatch(setIsFavoriteOpen(false))
                    dispatch(setSelectedItem(undefined))
                    dispatch(setSelectedItemIndex(undefined))
                    dispatch(setIsSettingsOpen(!isSettingsOpen))
                    dispatch(setIsInfoOpen(false))
                    dispatch(setIsMenuOpen(false))
                    dispatch(setIsPlay(true))
                }}>
                <Gear/>
            </SettingsBottomButton>
        </FooterWrapper>
    )
}

export default React.memo(Footer)

export const FooterWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 120px;
    //max-width: 390px;
    max-width: 545px;
    width: 100%;
    box-sizing: border-box;
    @media (max-height: 940px) {
        height: 140px;
        max-width: 390px;
    }
    @media (max-height: 800px) {
        height: 120px;
        max-width: 390px;
    }
`
